import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, BaseCommonComponent, UserService, NotificationService } from 'yt-ng-framework';
import { Component, OnInit } from "@angular/core";
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'yt-rekapitulacija',
    templateUrl: './rekapitulacija.component.html'
})

export class RekapitulacijaComponent extends BaseCommonComponent
  implements OnInit {
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        // protected notificationService: NotificationsService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected userService: UserService,
        protected modalService: ModalService
    ) {
        super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
    }

     ngOnInit() {
        super.ngOnInit();
     
        let dateNow = new Date();
        //let odDatuma = new Date(dateNow.getFullYear(), dateNow.getMonth() - 1, 1);
        this.baseFormGroup = new FormGroup({
            OdDatuma: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, 1), [Validators.required]),
            DoDatuma: new FormControl(new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate()), [Validators.required]),
            VrstaTroska: new FormControl(null, [Validators.required]),
            OrgJed: new FormControl(null, [Validators.required]),
            KomitentID: new FormControl(null,[Validators.required]),
            //SortBy: new FormControl(null, [Validators.required]),                         
            SortBy: new FormControl('1'),
            Vrsta: new FormControl('1')
        })     
    
        
        //this.addValidatorToFc("SortBy",Validators.required, 'required','REKAPITULACIJATROSKOVA.GRUPISANJE.VALIDATION.REQUIRED');
        //this.addValidatorToFc("OrgJed",Validators.required, 'required','REKAPITULACIJATROSKOVA.ORGJED.VALIDATION.REQUIRED');
        //this.addValidatorToFc("VrstaTroska",Validators.required, 'required','REKAPITULACIJATROSKOVA.VRSTATROSKA.VALIDATION.REQUIRED');   
    }
   
}
